import {getMomentTime} from 'app/utils/time/getMomentTime';
import moment from 'moment';

const getMomentDiffHours = (val: number): number => moment.duration(moment().diff(getMomentTime(val))).asHours();

export default getMomentDiffHours;
